module.exports = __webpack_public_path__ + "img/signal.11ee4bd0.svg";